import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class OfferEditSessionService {
  private readonly storageService = inject(StorageService);

  public getEditSessions(): Record<string, string> {
    return (
      this.storageService.getSessionItem<Record<string, string>>(
        'offer-edit-sessions'
      ) ?? {}
    );
  }

  public getEditSession(offerId: string): string | undefined {
    return this.getEditSessions()[offerId];
  }

  public setEditSession(offerId: string, editSessionId: string): void {
    const sessions = this.getEditSessions();
    sessions[offerId] = editSessionId;
    this.storageService.setSessionItem('offer-edit-sessions', sessions);
  }

  public removeEditSession(offerId: string): void {
    const sessions = this.getEditSessions();
    delete sessions[offerId];
    this.storageService.setSessionItem('offer-edit-sessions', sessions);
  }
}
